module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=QA - Qatar.47ad88d7.svg";